export class Acesso{
	
	idModulo:number;
	nomeModulo:string;
	altera:boolean;
	consulta:boolean;
	deleta:boolean;
    insere:boolean;
}